import React, { useEffect } from "react";
import { Navigation } from "./navigation";

import { useLocation } from "react-router-dom";

export const ContestRules = (props) => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const isMobileApp = searchParams.get("mobile") || 0;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div>
      {isMobileApp != 1 && <Navigation whiteBg={true} />}
      <div
        id="terms-condition-privacy"
        className={`container ${
          isMobileApp === 1 ? "container-mobileapp" : ""
        }`}
      >
        {!isMobileApp && <div className="terms-spacer" />}
        <div className="row">
          <div className="col-lg-12 col-sm-12 col-md-12 col-xs-12 mb-4">
            <h3 id="privacy-notice">
              🏆 Ace PDG Leaderboard Challenge — Official Rules
            </h3>
            <h5>
              Sponsor: This contest is sponsored by Ace Military Apps LLC,
              developer of the Ace PDG+SJT app. It is not sponsored or endorsed
              by Apple Inc. or Google LLC.
            </h5>
            <div>
              <p>Eligibility & Dates</p>
              <ul>
                <li>
                  Open to Ace PDG+SJT users preparing for USAF E-5 (SSgt) or E-6
                  (TSgt) ranks.
                </li>
                <li>Runs from January 1st – December 1st (US Pacific Time).</li>

                <li>
                  Winners will be determined at 11:59 PM PT on December 1st and
                  announced via in-app notification and app Settings page on or
                  around December 2nd.{" "}
                </li>
                <li>
                  Claim period will be between December 2nd – December 31st.
                </li>
                <li>
                  Winners must redeem prize by clicking claim prize in Settings
                  or emailing acepdgapp@gmail.com (user verification required).{" "}
                </li>
                <li>
                  Top 3 users on the TSgt and SSgt Leaderboard (6 total prizes)
                  will be eligible.
                </li>
                <li>
                  Participation requires an active Premium subscription. Void
                  where prohibited.
                </li>
              </ul>
            </div>

            <div>
              <p>How to Enter</p>
              <ul>
                <li>
                  Take unlimited mock exam(s) in the Ace PDG+SJT app during the
                  contest period.
                </li>
                <li>
                  Leaderboard placement is determined by verified mock-exam
                  scores.
                </li>
              </ul>
            </div>
            {/* SEPARATOR */}
            <div>
              <p>Prizes</p>
              <ul>
                <li>
                  Gold — $100 e-gift card; Silver — $50 e-gift card; Bronze —
                  $25 e-gift card.
                </li>
                <li>
                  Prizes delivered electronically to verified winners.
                  Non-transferable, no cash value.
                </li>
              </ul>
            </div>

            {/* SEPARATOR */}
            <div>
              <p>Verification & Deadlines</p>
              <ul>
                <li>All claims must be submitted by Dec 31 at 11:59 PM PT.</li>
                <li>
                  Ace Military Apps LLC will verify rank, score, and eligibility
                  before issuing prizes.
                </li>

                <li>Fraudulent or duplicate entries may be disqualified.</li>
              </ul>
            </div>
            {/* SEPARATOR */}
            <div>
              <p>Data Use:</p>
              <ul>
                <li>
                  Emails collected via the Claim Prize form are used only to
                  deliver prizes in accordance with our Privacy Policy.
                </li>
                {/* <li>
                  Ace Military Apps LLC will verify rank, score, and eligibility
                  before issuing prizes.
                </li>

                <li>Fraudulent or duplicate entries may be disqualified.</li> */}
              </ul>
            </div>
            <div>
              <p>
                Participation constitutes agreement to these Official Rules and
                the Ace Military Apps LLC Terms of Service. Rules subject to
                change.{" "}
              </p>
              <p>© 2025 Ace Military Apps LLC · All rights reserved.</p>
            </div>
          </div>

          <div className="spacer" />
          <div className="spacer" />
        </div>
        {/* <Footer /> */}
      </div>
    </div>
  );
};
